export const GENDER_OPTIONS = [
  { value: "", label: "Not set" },
  { value: "MALE", label: "Male" },
  { value: "FEMALE", label: "Female" },
  { value: "OTHER", label: "Other" },
];

export const STATUS_OPTIONS = [
  { value: "ACTIVE", label: "Active" },
  { value: "PENDING", label: "Pending" },
  { value: "INACTIVE", label: "Inactive" },
  { value: "SUSPENDED", label: "Suspended" },
];

export const cleanValue = (value) => {
  if (value === null || value === undefined) return "";
  if (value === "None") return "";
  return String(value);
};

export const getDisplayName = (user = {}) =>
  `${cleanValue(user?.firstName)} ${cleanValue(user?.lastName)}`.trim() ||
  cleanValue(user?.fullName) ||
  cleanValue(user?.username) ||
  cleanValue(user?.email) ||
  "Profile";

export const getInitials = (user = {}) => {
  const first = cleanValue(user?.firstName);
  const last = cleanValue(user?.lastName);
  if (first || last) {
    return `${first[0] || ""}${last[0] || ""}`.toUpperCase();
  }

  const name = getDisplayName(user);
  const parts = String(name).trim().split(/\s+/).filter(Boolean);
  if (parts.length > 1) {
    return `${parts[0][0] || ""}${parts[1][0] || ""}`.toUpperCase();
  }
  return String(name || "U").slice(0, 2).toUpperCase();
};

export const formatDate = (value) => {
  if (!value) return "Not provided";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return String(value);
  return date.toLocaleDateString(undefined, {
    year: "numeric",
    month: "short",
    day: "numeric",
  });
};

export const formatDateTime = (value) => {
  if (!value) return "Not provided";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return String(value);
  return date.toLocaleString(undefined, {
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
};

export const getStatusColor = (status = "") => {
  const normalized = String(status).toUpperCase();
  if (normalized === "ACTIVE") return "success";
  if (normalized === "PENDING") return "warning";
  if (normalized === "SUSPENDED") return "danger";
  if (normalized === "INACTIVE") return "secondary";
  return "secondary";
};

